import instance from '@/utils/request/index';
import { AxiosResponse } from 'axios';
export default {
  /**
   * 系统-登录
   */
  async authLogin(param: any) {
    const response: AxiosResponse = await instance.post('/user/login', param);
    return response.data;
  },
  /**
   * 系统-注册
   */
  async authRegister(param: any) {
    const response: AxiosResponse = await instance.post('/user/register', param);
    return response.data;
  },
  /**
   * 系统-登录发送验证码
   */
  async authLoginSendCode(param: any) {
    const response: AxiosResponse = await instance.post('/user/loginSmsSend', param);
    return response.data;
  },
  /**
   * 系统-注册发送验证码
   */
  async authRegisterSendCode(param: any) {
    const response: AxiosResponse = await instance.post('/user/registerSmsSend', param);
    return response.data;
  },
  /**
   * 系统-注册校验
   */
  async authRegisterCheck(param: any) {
    const response: AxiosResponse = await instance.post('/user/registerCheck', param);
    return response.data;
  },
  /**
   * 系统-用户详情
   */
  async getUserDetail(param: any) {
    const response: AxiosResponse = await instance.post('/user/get', param);
    return response.data;
  },
  /**
   * 系统-用户修改密码
   */
  async editPassword(param: any) {
    const response: AxiosResponse = await instance.post('/user/editPassword', param);
    return response.data;
  },
  /**
   * 系统-用户修改密码发送验证码
   */
  async editPasswordSmsSend(param: any) {
    const response: AxiosResponse = await instance.post('/user/editPasswordSmsSend', param);
    return response.data;
  },
};
